






























































































import { Component, Emit, Model, Prop, Watch } from 'vue-property-decorator';
import { ViewpointApi, VIEWPOINT_API } from '@/api/ViewpointApi';
import Apps from '@/store/modules/Apps';
import Vue from 'vue';
import { getModule } from 'vuex-module-decorators';
import Decisions from '@/store/modules/Decisions';
import { AppModel } from '@/api/model/AppModel';
import CardTitle from '@/components/common/CardTitle.vue';
import _ from 'lodash';
import { watch } from 'fs';

const appsModule = getModule(Apps);
const decisionsModule = getModule(Decisions);
@Component({
    components: { CardTitle },
})
export default class TemplateLaunchDialog extends Vue {

    @Prop({default: false, type: Boolean})
    decisionSelector!: boolean

    @Prop({default: '', type: String})
    decisionName!: string

    @Prop({ default: '', type: String })
    selectedDecisionTemplateId!: string;

    private show = false;
    private newDecisionName = '';
    private includeChoices = false;
    private includeViewpoints = false;
    private includeApps = true;
    private includeLists = false;
    private includeComments = false;
    private includeUsers = false;

    @Watch('includeUsers')
    private onChangeIncludeUsers() {
        if (!this.includeUsers) {
            this.includeUsers = false;
        }
    }

    @Watch('show')
    private onChangeShow() {
        if (this.show) {
            this.newDecisionName = '';
        }
    }

    @Emit('save')
    private save() {
        this.show = false;
        return {
            newTemplateDecisionId: this.selectedDecisionTemplateId,
            newDecisionName: this.newDecisionName,
            options: {
                includeChoices: this.includeChoices,
                includeViewpoints: this.includeViewpoints,
                includeApps: this.includeApps,
                includeLists: this.includeLists,
                includeComments: this.includeComments,
                includeUsers: this.includeUsers
            },
        };
    }
}
